function decode(str) {
  // 一般可以先转换为标准 unicode 格式（有需要就添加：当返回的数据呈现太多\\\u 之类的时）
  str = unescape(str.replace(/\\u/g, "%u"));
  // 再对实体符进行转义
  // 有 x 则表示是16进制，$1 就是匹配是否有 x，$2 就是匹配出的第二个括号捕获到的内容，将 $2 以对应进制表示转换
  str = str.replace(/&#(x)?(\w+);/g, function($, $1, $2) {
    return String.fromCharCode(parseInt($2, $1? 16: 10));
  });

  return str;
}
export default {
  methods: {
    getLanguage () {
      let lang = window.navigator.language
      lang = lang.substr(0, 2);
      if (this.lan) {
        if (this.lan === 'en') {
          sessionStorage.setItem('lan', 'en')
        } else {
          sessionStorage.setItem('lan', 'zh')
          this.setLanguage()
        }
      } else {
        if (lang != 'zh') {
          sessionStorage.setItem('lan', 'en')
        } else {
          sessionStorage.setItem('lan', 'zh')
        }
      }
    },
    setTitle(title) {
      title = decode(title)
      document.title = title;
      if (this.isWX()) {
        let ifr = document.createElement('iframe')
        ifr.src = '/favicon.ico'
        ifr.style.display = 'none'
        var load = function() {
          setTimeout(function() {
            ifr.parentNode.removeChild(ifr)
            load = null
          }, 0)
        }
        ifr.addEventListener('load', load)
        document.getElementsByTagName('body')[0].appendChild(ifr)
      }
    },
    isMobile() {
      let width = window.screen.width || window.screen.availWidth || document.documentElement.scrollWidth
      this.ifMobile = /Android|webOS|iPhone|iPod|Windows Phone|SymbianOS|BlackBerry/i.test(navigator.userAgent) || width < 500
    },
    // 检查是否微信
    isWX() {
      var ua = navigator.userAgent.toLowerCase()
      return ua.match(/MicroMessenger/i) == 'micromessenger'
    },
    // 检查是否QQ
    isQQ() {
      var ua = navigator.userAgent.toLowerCase()
      return (ua.match(/mobile\smqqbrowser/i) == 'mobile mqqbrowser' ||
        (ua.match(/qq/i) == 'qq' && ua.match(/(iPhone|mac|iPod|iPad;?)/i)))
    },
    // 检查 安卓 / iOS / Other
    checkUa() {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.match(/android/i)) {
        return 'android'
      } else if (ua.match(/(iphone|ipod|ipad;?)/i)) {
        return 'ios'
      } else {
        return 'other'
      }
    },
    // 直接下载
    downloadFile(url) {
      console.log('downloadFile'+url)
      console.log('url...', url)
      let elemIF = document.createElement('iframe')
      elemIF.src = url
      elemIF.style.display = 'none'
      document.body.appendChild(elemIF)
    },
  }
}



// WEBPACK FOOTER //
// ./components/clientCommonMixin.js